import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

const CategorySubMenuItem = props => (
  ComposeSubMenuItem(
    props.type,
    props.path,
    props.label,
    props.categoryId,
    props.subCategoryId,
    props.enabled,
    props.className,
    props.parentClassName,
    props.hasItems
  )
)

const ComposeSubMenuItem = (
  type,
  path,
  label,
  categoryId,
  subCategoryId,
  enabled,
  className,
  parentClassName,
  hastItems
) => {
  const reloadScreen = () => {
    setTimeout(() => {
      window.location.reload()
    }, 500)
  }

  switch (enabled) {
    case true:
      switch (type) {
        case 'category':
          return (
            <div className={`row mx-0 ${parentClassName} item-without-submenu`}>
              <div className='col'>
                <Link
                  to={`/search?category=${categoryId}`}
                  className={`link-profile txt-font-body txt-body-sm px-1 py-1 ${className}`}
                  onClick={() => reloadScreen()}
                >
                  {label}
                </Link>
              </div>
            </div>
          )
        case 'sub-category':
          return (
            <div className={`row mx-0 ${parentClassName} item-without-submenu`}>
              <div className='col'>
                <Link
                  to={`/search?subcategory=${subCategoryId}`}
                  className={`link-profile txt-font-body txt-body-sm px-1 py-1 ${className}`}
                  onClick={() => reloadScreen()}
                >
                  {label}
                </Link>
              </div>
            </div>
          )
        case 'services':
          return label === 'Passagens' || label === 'Hotéis' || label === 'Carros' || label === 'Passeios' ? (
            <div className={`row mx-0 ${parentClassName} item-without-submenu`}>
              <div className='col'>
                <a
                  href={`${path}`}
                  className={`link-profile txt-font-body txt-body-sm px-1 py-1 ${className}`}
                  onClick={() => reloadScreen()}
                >
                  {label}
                </a>
              </div>
            </div>
          ) : (
            <div className={`row mx-0 ${parentClassName} item-without-submenu`}>
              <div className='col'>
                <Link
                  to={`${path}`}
                  className={`link-profile txt-font-body txt-body-sm px-1 py-1 ${className}`}
                  onClick={() => reloadScreen()}
                >
                  {label}
                </Link>
              </div>
            </div>
          )
        case 'services-external':
          return (
            <div className={`row mx-0 ${parentClassName} item-without-submenu`}>
              <div className='col'>
                <a
                  href={`${path}`}
                  className={`link-profile txt-font-body txt-body-sm px-1 py-1 ${className}`}
                  onClick={() => reloadScreen()}
                  target='_blank'
                >
                  {label}
                </a>
              </div>
            </div>
          )
      }
  }
}

CategorySubMenuItem.propTypes = {
  type: PropTypes.string,
  path: PropTypes.string,
  label: PropTypes.string,
  categoryId: PropTypes.number,
  subCategoryId: PropTypes.number,
  enabled: PropTypes.string,
  className: PropTypes.string,
  parentClassName: PropTypes.string,
  hasItems: PropTypes.bool
}

export default CategorySubMenuItem



// WEBPACK FOOTER //
// ./src/App/MainMenu/CategoryMenu/CategorySubMenuItem.js